/**
 * @module JobItem
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { truncate } from '@lifechurch/web-tools-io/dist/utils/helpers/truncate';

/**
 * Represents a Careers page Job list item.
 *
 * @param {object} props - The component props object.
 * @param {Job} props.job - The object containing the job data.
 *
 * @returns {React.ReactElement} The JobItem component.
 */
export default function JobItem({ job }) {
  return job ? (
    <a
      className="job-item"
      href={job.hostedUrl}
      rel="noreferrer"
      target="_blank"
    >
      <h3 className="mb-tighter mt-normal">{job.title}</h3>
      <p className="job-team-title mb-normal">{job.teamTitle}</p>
      <p className="job-description mb-normal">
        {truncate(job.description, 200)}
      </p>
    </a>
  ) : null;
}
